/**
 * «Загрузить телефоны Квестгида (файл с компьютера)» — в панели дат брони Квестгида (27.10.2026, только ЕО).
 * Файл kvestgid-phones.json выбирается на компьютере, разбирается в браузере (kvestgidPhonesModel.ts) и после подтверждения уходит
 * на сервер частями по 800 строк. Сервер пишет только пустые телефоны строк Квестгида и отвечает счётчиками — хешей в ответе нет.
 */
import { useRef, useState } from "react";
import { api } from "../../api/client";
import { ConfirmModal } from "../../components/shared";
import { parsePhonesFile, phoneChunks, phonesSummary, sumPhones, PHONES_PART, type PhoneRow, type PhonesResult } from "./kvestgidPhonesModel";
import css from "./kvestgidOrigin.module.css";

export function KvestgidPhonesUpload({ onDone }: { onDone: () => void }) {
  const input = useRef<HTMLInputElement>(null);
  const [ready, setReady] = useState<PhoneRow[] | null>(null);
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");

  const reset = () => { if (input.current) input.current.value = ""; };
  const pick = async (file: File | undefined) => {
    setMsg("");
    if (!file) return;
    const got = parsePhonesFile(await file.text());
    reset();
    if ("error" in got) setMsg(got.error);
    else setReady(got.rows);
  };
  const send = async (rows: PhoneRow[]) => {
    setReady(null);
    const parts = phoneChunks(rows);
    const done: PhonesResult[] = [];
    try {
      for (const [i, part] of parts.entries()) {
        setBusy(`Отправляю телефоны: часть ${i + 1} из ${parts.length}…`);
        done.push(await api<PhonesResult>("/api/eo/kvestgid-origin/phones", { method: "POST", body: { rows: part } }));
      }
      setMsg(phonesSummary(sumPhones(done)));
    } catch (e) {
      setMsg(`${e instanceof Error ? e.message : "Ошибка"}${done.length ? ` (отправлено частей: ${done.length} из ${parts.length})` : ""}`);
    }
    setBusy("");
    onDone();
  };

  return (
    <>
      <div className={css.actions}>
        <button type="button" className={css.undo} disabled={!!busy} onClick={() => input.current?.click()}>Загрузить телефоны Квестгида (файл с компьютера)</button>
        <input ref={input} type="file" accept=".json,application/json" hidden onChange={(e) => void pick(e.target.files?.[0])} />
        {busy ? <span className={css.muted}>{busy}</span> : null}
      </div>
      {msg ? <div className={css.toast} role="status">{msg}</div> : null}
      {ready ? (
        <ConfirmModal tone="warn" title="Записать телефоны из Квестгида?" actionLabel="Записать"
          onAction={() => void send(ready)} onCancel={() => setReady(null)}>
          {`В файле ${ready.length.toLocaleString("ru-RU")} строк — уйдут частями по ${PHONES_PART}. Запишутся только пустые телефоны истории Квестгида и игр без сумм; остальные брони не меняются. Откат — «Откатить» этой панели.`}
        </ConfirmModal>
      ) : null}
    </>
  );
}
